import { ComplexValue } from 'app/types-shared';
import { ValidationLevel, ValidationProps } from 'ui';
import { SearchFiltersTranslation } from '../../constants';
import { ValidationFilter } from './types';

const matchNumberAndSeparatorsForInt = /^((\s*\d+\s*)|(\s*\d+\s*-\s*\d+\s*))(,((\s*\d+\s*)|(\s*\d+\s*-\s*\d+\s*)))*,?\s*$/m;

const validate = (validateRegex: RegExp): ValidationFilter => (
  values: ComplexValue<number | string>[],
  translation: SearchFiltersTranslation
): ValidationProps => {
  const isFilterValid = values
    .map(value => value?.value?.toString()?.replace(/\s/g, ' ')?.trim() ?? '')
    .every(value => value === '' || validateRegex.test(value));
  return !isFilterValid
    ? {
      level: ValidationLevel.error,
      messages: [{
        level: ValidationLevel.error,
        message: translation.number_validator_error
      }]
    } : undefined;
};

export const intValidate = validate(matchNumberAndSeparatorsForInt);
